import { createFileRoute } from '@tanstack/react-router';
import { AdminRoadmapView } from '@/components/admin/roadmap';

interface RoadmapSearch {
  readonly tab?: 'all';
}

export const Route = createFileRoute('/_authed/admin/roadmap/')({
  // A rejected key is returned as explicit `undefined`: the router merges this
  // result over the raw URL search, so an omitted key would let the raw value
  // through to `useSearch()`.
  validateSearch: (raw: Record<string, unknown>): RoadmapSearch => ({
    tab: raw.tab === 'all' ? 'all' : undefined,
  }),
  component: AdminRoadmapPage,
});

function AdminRoadmapPage() {
  const { tab } = Route.useSearch();
  return <AdminRoadmapView tab={tab ?? 'review'} itemId={null} />;
}
